import { ManifoldMonoBadgeIcon } from "~/assets/icons";
import { cn } from "~/lib/utils";

export const INTERNAL_TAG_NAME = "manifold";

interface TagLabelProps {
  tagName: string;
  className?: string;
}

const TagLabel = ({ tagName, className }: TagLabelProps) => {
  if (tagName.includes(INTERNAL_TAG_NAME)) {
    return (
      <span className={cn("inline-flex items-center gap-0.5 min-w-0", className)}>
        <span className="truncate">{tagName}</span>
        <ManifoldMonoBadgeIcon className="w-[14px] h-[11px] shrink-0" />
      </span>
    );
  }
  return (
    <span className={cn("inline-flex items-center min-w-0", className)}>
      <span className="truncate">{tagName}</span>
    </span>
  );
};

export default TagLabel;
